var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import { fromPromise } from 'mobx-utils';
export class BrowserIncludes {
    parent;
    loadedStyleSheetUrls = typeof window !== 'undefined' ? window.prematureStylesheetLoads : [];
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    async loadJQuery() {
        await this.includeJSFileOnce('/lib/jquery/jquery-3.2.1.min.js');
        return window.$;
    }
    loadedJsFiles = new Map();
    includeJSFileOnce(url) {
        // small promise based script loader: https://github.com/buzinas/smallest-script-loader/blob/master/src/index.js
        if (this.loadedJsFiles.has(url)) {
            return this.loadedJsFiles.get(url);
        }
        const script = document.createElement('script');
        script.async = true;
        const promise = fromPromise(new Promise((resolve, reject) => {
            script.addEventListener('load', resolve);
            script.addEventListener('error', () => reject(new Error(`Failed to load the script: ${url}.`)));
            let src = url;
            /* if (runtime.isBrowserRuntime && url.charAt(0) === '/') {
              // add nodejs server prefix
              src = runtime.solidBrowserRuntime.app.appHost.nodeHref + url;
            } */
            script.src = src;
            document.head.appendChild(script);
        }));
        this.loadedJsFiles.set(url, promise);
        return this.loadedJsFiles.get(url);
    }
    loadedCssFiles = new Map();
    async includeCSSFileOnce(cssUrl) {
        if (!this.loadedCssFiles.get(cssUrl)) {
            this.loadedCssFiles.set(cssUrl, true);
            const link = document.createElement('link');
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('type', 'text/css');
            link.setAttribute('href', cssUrl);
            link.onload = () => {
                this.addLoadedStylesheet(cssUrl);
            };
            document.head.appendChild(link);
        }
    }
    loadedCssClasses = new Map();
    includeCSSCodeOnce(name, cssCode) {
        if (!this.loadedCssClasses.get(name)) {
            this.loadedCssClasses.set(name, true);
            const style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = cssCode;
            document.getElementsByTagName('head')[0].appendChild(style);
        }
    }
    addLoadedStylesheet(stylesheetUrl) {
        this.loadedStyleSheetUrls.push(stylesheetUrl);
    }
    isStylesheetLoaded(stylesheet) {
        return this.loadedStyleSheetUrls.includes(stylesheet);
    }
}
__decorate([
    observable.shallow
], BrowserIncludes.prototype, "loadedStyleSheetUrls", void 0);
__decorate([
    observable.shallow
], BrowserIncludes.prototype, "loadedJsFiles", void 0);
__decorate([
    action.bound
], BrowserIncludes.prototype, "includeJSFileOnce", null);
__decorate([
    action.bound
], BrowserIncludes.prototype, "addLoadedStylesheet", null);
